import { useMsal } from '@azure/msal-react';
import AccountCircleIcon from 'Assets/Icons/account_circle.svg';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
//icons
import SettingsIcon from '@mui/icons-material/Settings';
import { NavigationPillBar } from 'Components/Navigation';
import { MultiModalProvider, useGlobalState } from 'Context';
import { NotificationModel } from 'Models';
import { ENDPOINTS } from 'Models/Templates/Routes/Routes';
import {
  MAIN_NAV_CONFIG,
  NavConfigItem,
  ROUTES,
  SETTINGS_NAV_CONFIG,
  useNavigation,
} from 'Navigation';
import React, { Fragment } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { Link, useHistory } from 'react-router-dom';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';
import { buildRoute, asyncLogout, HOTKEYS, useToggler } from 'Utilities';
import logo from '../../Assets/Logo.svg';
import './Header.scss';
import { GlobalSearch } from 'v3/Components/Shared/GlobalSearch';
import { SecureComponent } from 'Components/Security';
import { Permission } from 'Models/Templates/Permission/Permission';

export enum HeaderModal {
  NotificationsDrawer = 'NotificationsDrawer',
}

type HeaderProps = {
  [x: string]: any;
};

export const Header: React.FC<HeaderProps> = () => {
  const { environmentName } = useGlobalState();
  let history = useHistory();
  const { currentUser } = useGlobalState();
  const clientLogo = currentUser?.clientNames?.[0];
  const showClientLogo = (currentUser?.isClient || currentUser?.isAdjuster) && currentUser?.clientNames?.length === 1;
  const redirectToDetailedSearch = () => {
    history.push(buildRoute(ROUTES.DETAILED_SEARCH));
  };

  useHotkeys(HOTKEYS.DETAILED_SEARCH, redirectToDetailedSearch);

  return (
    <div className="header__content flex-vertical-center full-size flex-normal">
      <div
        className="flex-vertical-center "
        style={{ justifyContent: 'flex-start', marginLeft: 60 }}
      >
        <Link to="/">
          <div className="color-success font-secondary site-logo-container ">
            <img src={logo} alt="Stradix" className="site-logo" />
          </div>
        </Link>
        {clientLogo && showClientLogo && (
          <span
            style={{
              color: 'white',
              textTransform: 'uppercase',
              whiteSpace: 'nowrap',
              fontFamily: "NotoSans"
            }}
          >
            | {clientLogo}
          </span>
        )}
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          width: '100%',
          alignItems: 'center',
        }}
      >
        <NavigationPillBar pills={MAIN_NAV_CONFIG} />
        <HeaderToolbar />
      </div>
    </div>
  );
};

const HeaderToolbar: React.FC = () => {
  return (
    <MultiModalProvider>
      <div className="color-light flex-normal flex-vertical-center toolbar-buttons">
        <HeaderDropdowns />
      </div>
    </MultiModalProvider>
  );
};

const HeaderDropdowns: React.FC = () => {
  return (
    <Fragment>
      {/* <NotificationsButton /> */}
      {/* 
      <SettingsDropdown /> */}
      <SecureComponent permissions={[Permission.GlobalSearch]}>
        <GlobalSearch onSearch={(query: string) => { console.log('Searching for:', query); }} />
      </SecureComponent>
      <AccountDropdown />
    </Fragment>
  );
};

export type NotificationsLocalState = {
  notifications: NotificationModel[];
  page: number;
  skip: number;
};

const SettingsDropdown: React.FC = () => {
  const [settingsIsOpen, toggleSettingsMenu] = useToggler(false);
  const { navConfig } = useNavigation(SETTINGS_NAV_CONFIG);

  return (
    <Dropdown isOpen={settingsIsOpen} toggle={toggleSettingsMenu}>
      <DropdownToggle className="bg-transparent border-none main-menu-item">
        <SettingsIcon />
      </DropdownToggle>
      <DropdownMenu
        className="animate-fade-in card-shadow color-secondary"
        right
      ></DropdownMenu>
    </Dropdown>
  );
};
const Icon = () => (
  <img src={AccountCircleIcon} alt="Account" className="header-icon" />
);

const AccountDropdown: React.FC = () => {
  const { currentUser } = useGlobalState();
  const [isDropdownOpen, toggleDropdown] = useToggler();
  const editProfileLink = '/AddEdit/User/' + currentUser?.id;
  const { instance } = useMsal();

  const fullName = `${currentUser?.firstName} ${currentUser?.lastName}`;
  const { navConfig } = useNavigation(SETTINGS_NAV_CONFIG);
  const userLogOut = async () => {
    const logoutUrl = 'api/' + ENDPOINTS.users.endpointString('logout');
    await asyncLogout(logoutUrl, localStorage.getItem('sessionId'));
    localStorage.removeItem('sessionId');
    sessionStorage.clear();
    await instance.logoutRedirect();
  };

  return (
    <Fragment>
      <Dropdown
        isOpen={isDropdownOpen}
        style={{ marginRight: 60 }}
        toggle={toggleDropdown}
      >
        <DropdownToggle className="bg-transparent border-none main-menu-item">
          <div className="cta-wrapper">
            <Icon />
            <span>{fullName}</span>
          </div>
        </DropdownToggle>
        <DropdownMenu className="animate-fade-in card-shadow" right>
          <DropdownItem header className="color-secondary">
            Admin
          </DropdownItem>
          {navConfig.map((pill: NavConfigItem, index: any) => (
            <Link to={pill.fullRoute || '/'} key={index}>
              <DropdownItem className="flex-vertical-center">
                <div className="dropdown-icon">{pill.icon}</div>
                {pill.label}
              </DropdownItem>
            </Link>
          ))}
          <DropdownItem header className="color-secondary">
            <span>{fullName}</span>
          </DropdownItem>
          <Link to={editProfileLink}>
            <DropdownItem className="flex-vertical-center">
              Edit Profile
            </DropdownItem>
          </Link>
          <DropdownItem className="flex-vertical-center" onClick={userLogOut}>
            <ExitToAppIcon className="mr-small color-primary" />
            Log Out
          </DropdownItem>{' '}
        </DropdownMenu>
      </Dropdown>
      {/* <span className="color-primary mr-small">
        Hello, {currentUser?.firstName}
      </span> */}
    </Fragment>
  );
};
